var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","margin":"0","padding":"0"}},[_c('tui-image-editor',{ref:"tuiImageEditor",staticClass:"fusion-tui-image-editor-main-wrapper",attrs:{"include-ui":_vm.useDefaultUI,"options":_vm.options},on:{"hook:mounted":function($event){return _vm.tuiImageEditorMounted()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }